<template>
	<div class="app-view jobs-center-view">
		<header class="app-view__header">
			<h1 class="headline">Job Requests</h1>
		</header>

		<div class="jobs-center__filters-wrapper">
			<div>
				<quick-filters/>
			</div>
			<div :class="['filter-actions', 'btn-index', {'open':filterOpenState}]">
				<job-filter v-if="showFilter" />
			</div>	
		</div>

		<main class="app-view__content">
			<div v-responsive:sila="['hidden-all', 'large', 'xlarge']">
				<jobs-request-grid/>
			</div>
			<div v-responsive:sila="['hidden-all', 'small', 'medium']">
				<jobs-request-cards/>
			</div>
		</main>


		<!-- wrap in case we need more stuff ... i knew it would come in handy, overflow! -->
		<div v-if="!mobile" class="fab-wrapper">
			<v-btn
				v-if="canCreateRequest"
				fab color="primary"
				class="create-job-btn"
				@click="startNewJobFlow">
				<v-icon>add</v-icon>
			</v-btn>
		</div>
		<create-job />
	</div>
</template>

<script>
	import { mapActions, mapGetters, mapState } from 'vuex'
	
	import { VUEX_JOB_CREATE_INIT } from '@/store/constants/jobs'
    import {
        VUEX_USERS_GET_USERS_BY_ROLE_NO_PENDING,
        VUEX_USERS_GET_USERS_BY_ROLE_ACTIVE
    } from '@/store/constants/users'

	import { VUEX_ROUTING_EXIT_REQUEST } from '@/store/constants/routing'

	import JobsRequestGrid from '@/components/ui/Jobs/Jobs_Request_Grid'
	import JobsRequestCards from '@/components/ui/Jobs/Jobs_Request_Cards'
	import CreateJob from '@/components/ui/Jobs/Create_Job.vue'
	import QuickFilters from '@/components/ui/Jobs/Jobs_Quick_Filters.vue'
	import JobFilter from '@/components/ui/Jobs/Job_Filter.vue'
	import JobSearch from '@/components/ui/Jobs/Job_Search.vue'


	export default {
		name: 'jobs-manage-view',

		components: {
			'jobs-request-grid'  : JobsRequestGrid,
			'jobs-request-cards' : JobsRequestCards,
			'create-job'        : CreateJob,
			'quick-filters'     : QuickFilters,
			'job-filter'        : JobFilter,
			'job-search'        : JobSearch
		},

        mounted() {
            this.getUsersByRoleNoPending()
            this.getUsersByRoleActive()
        },

		computed: {
			...mapState({
				mobile: state => state.mobile.mobile,
				filterOpenState: state => state.ui.jobFilterOverlay.openState,
			}),

			...mapGetters({
				currentUserHasPerm: 'currentUserHasPerm',
                currentUserHasRole: 'currentUserHasRole',

			}),

			canCreateRequest() {
				return this.currentUserHasPerm(SILA_PERMISSION_JOBS_JOB_CREATE)
			},

            showFilter() {
                return true
            },

		},

		methods: {

			...mapActions({
				startNewJobFlow: VUEX_JOB_CREATE_INIT,
				saveExitState: VUEX_ROUTING_EXIT_REQUEST,
                getUsersByRoleNoPending: VUEX_USERS_GET_USERS_BY_ROLE_NO_PENDING,
                getUsersByRoleActive: VUEX_USERS_GET_USERS_BY_ROLE_ACTIVE,

			})
		},
		
		beforeRouteLeave(to, from, next){
			if (document.body.style.position == 'fixed'){
                document.body.style.position = ''
            }
			this.saveExitState()
			next()
        }
	}
</script>


<style>
.btn-index {
	z-index:1;
}
</style>